module.exports = __webpack_public_path__ + "img/cjc1_style_3_font_sprite.291188a6.webp";